// @mui
import { Stack, Typography } from "@mui/material";
// routes
// import { PATH_AUTH } from "../../routes/paths";
// layouts
import LoginLayout from "../../layouts/login";
import LoginButton from "./LoginButton";

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: "relative" }}>
        <Typography variant="h4">Sign in to FVCA Admin Panel</Typography>
        <LoginButton />
      </Stack>
    </LoginLayout>
  );
}
